<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>
          {{ $t('role_btn_auth_menu') }}
          <span v-if="roleInfo" style="color:#1838d9"> ({{ roleInfo.name }}) </span>
        </h3>

        <div class="g-content-filter-right">
          <a-button
            type="default"
            @click="
              () => {
                this.$router.go(-1);
              }
            "
            icon="double-left"
          >
            {{ $t('com_btn_back') }}
          </a-button>
          <a-button type="primary" @click.prevent="authSubmit" :loading="loading">
            {{ $t('com_btn_save') }}
          </a-button>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="form">
        <a-form-model
          :model="form"
          :label-col="{ span: 10 }"
          :wrapper-col="{ span: 14 }"
          ref="formElement"
          class="item-list"
        >
          <!-- 递归 -->
          <AuthItem :data="list" :callback="callback" :checkedList="checkedList" />
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/role';
import AuthItem from './auth-menu-item.vue';
import { makeTree } from '@/libs/utils';

// 查找当前子类集合
function findChildren(currentMenu, data, newData) {
  // 选中当前menu/interface
  if (!newData.includes(currentMenu.key)) {
    newData.push(currentMenu.key);
  }

  // 菜单时才查找子集分类
  if (typeof currentMenu.menuId === 'undefined') {
    // 操作菜单

    // 把interface放入
    if (currentMenu.interface) {
      const interfaceAuthName = currentMenu.interface.map(inter => inter.key);
      interfaceAuthName.forEach(i => {
        if (!newData.includes(i)) {
          newData.push(i);
        }
      });
    }

    data.forEach(item => {
      if (item.parentId === currentMenu.id) {
        if (!newData.includes(item.key)) {
          newData.push(item.key);
        }
        if (item.interface) {
          const interfaceAuthName = item.interface.map(inter => inter.key);
          interfaceAuthName.forEach(i => {
            if (!newData.includes(i)) {
              newData.push(i);
            }
          });
        }
        findChildren(item, data, newData);
      }
    });
  }

  // console.log('newDatanewDatanewDatanewData', newData);

  return newData;
}

// 递归查找父级菜单
function findParentMenu(currentMenu, data, newData) {
  // 当前菜单的父级
  let parentMenu;

  // 当前接口的父级
  if (typeof currentMenu.menuId !== 'undefined') {
    parentMenu = data.find(item => item.id === currentMenu.menuId);
  } else {
    if (currentMenu.parentId) {
      parentMenu = data.find(item => item.id === currentMenu.parentId);
    }
  }

  if (parentMenu) {
    newData.push(`${parentMenu.id}`);

    // 递归
    findParentMenu(parentMenu, data, newData);
  }
  return newData;
}

// 查找同级
function findBrotherMenu(currentMenu, data, newData) {
  if (typeof currentMenu.menuId !== 'undefined') {
    // 当前接口的父级
    // 找到同级的所有接口
    const parentMenu = data.find(item => item.id === currentMenu.menuId);
    if (parentMenu) {
      if (parentMenu.interface) {
        const interfaceId = parentMenu.interface.map(item => `${currentMenu.menuId}-${item.id}`);
        newData = newData.concat(interfaceId);
      }

      // 父级的子菜单
      const childrenMenu = data.filter(item => item.parentId === parentMenu.id);

      // 父级的同级菜单
      // const parentBrother = data.filter(
      //   item => item.id === parentMenu.parentId
      // );
      // console.log(
      //   'parentBrotherparentBrotherparentBrotherparentBrother',
      //   parentBrother
      // );

      newData = newData.concat(childrenMenu.map(item => item.id));
    }
  } else {
    if (currentMenu.parentId) {
      // 同级
      const brotherMenu = data.filter(item => item.parentId === currentMenu.parentId);
      if (brotherMenu) {
        let brotherMenuIds = brotherMenu.map(item => `${item.id}`);
        brotherMenu.forEach(menu => {
          if (menu.interface) {
            const menuInterfaceIds = menu.interface.map(item => `${currentMenu.menuId}-${item.id}`);
            brotherMenuIds = brotherMenuIds.concat(menuInterfaceIds);
          }
        });

        newData = newData.concat(brotherMenuIds);
      }
    }
  }
  return newData;
}

export default {
  components: {
    AuthItem,
  },
  data() {
    return {
      checkedList: [],

      list: [],
      listAll: [],
      listRes: [],

      interface: [],
      menus: [],

      form: {},
      loading: false,

      // 角色id
      roleId: null,
      roleInfo: null,
    };
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.RoeId) {
      this.roleId = Number(this.$route.params.RoeId);
    }
    this.getData();
  },
  methods: {
    // 获取表单数据
    getData() {
      const _list = [this.getAllMenuInterface(), this.getRoleDetail()];

      Promise.all(_list).finally(() => {
        const newCheckList = [];
        // 清除不存在的key值
        this.listRes.forEach(menu => {
          if (this.checkedList.includes(menu.key)) {
            newCheckList.push(menu.key);
          }

          // 接口
          if (menu.interface) {
            menu.interface.forEach(mInterface => {
              if (this.checkedList.includes(mInterface.key)) {
                newCheckList.push(mInterface.key);
              }
            });
          }
        });
        this.checkedList = newCheckList;
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
      });
    },

    // 获取角色详情
    getRoleDetail() {
      return API.RoleDetail({ id: this.roleId }).then(res => {
        if (res.code === 0) {
          this.roleInfo = res.data;
          // 选中列表
          // const menuAuth = res.data.menuAuth || '';
          // const menuAuthArr = menuAuth.split(',');
          this.checkedList = res.data.keys ? res.data.keys.split(',') : [];
        }
      });
    },

    getAllMenuInterface() {
      return API.AllMenuInterface().then(res => {
        const reMenus = res.data.menus;
        const interfaces = res.data.interfaces;

        // MENUS过滤
        const menus = [];
        reMenus.forEach(menu => {
          if (!menu.common) {
            menus.push(menu);
          }
        });

        // 重组
        interfaces.forEach(item => {
          // 去掉通用的接口（通用的后台默认授权)
          if (!item.common) {
            item.label = item.name;
            item.key = `${item.menuId}-${item.id}`;

            menus.forEach(menu => {
              if (item.menuId === menu.id) {
                if (!menu.interface) {
                  menu.interface = [];
                }
                if (menu.interface) {
                  menu.interface.push(item);
                }
              }
            });
          }
        });

        // 去掉disabled
        const newMemnus = [];
        menus.forEach(item => {
          item.key = `${item.id}`;
          if (!item.disabled) {
            newMemnus.push(item);
          }
        });

        // 存储原数据
        this.listAll = interfaces.concat(newMemnus);

        this.listRes = newMemnus;

        this.interfaces = interfaces;
        this.menus = newMemnus;

        // tree
        const menuTree = makeTree({
          data: menus,
          idName: 'id',
          parentIdName: 'parentId',
        });
        this.list = menuTree.array;
      });
    },

    authSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          // 找出interface id
          const interfaceId = [];
          const menuId = [];
          this.checkedList.forEach(key => {
            if (/-/gi.test(key)) {
              const arr = key.split('-');
              if (arr.length === 2) {
                interfaceId.push(arr[1]);
              }
            } else {
              menuId.push(Number(key));
            }
          });

          const params = {
            id: this.roleId,
            interfaceIds: interfaceId.join(','),
            menuIds: menuId.join(','),
            keys: this.checkedList.join(','),
          };
          this.loading = true;
          API.RoleMenuAuth(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_save_success'));
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    callback(event) {
      const target = event.target;
      const value = target.value;
      const currentMenu = this.listAll.find(item => item.key === value);
      const actionIDs = findChildren(currentMenu, this.listRes, []);

      // 操作
      if (this.checkedList.includes(value)) {
        const newCheckedList = [];
        this.checkedList.forEach(key => {
          if (!actionIDs.includes(key)) {
            newCheckedList.push(key);
          }
        });
        this.checkedList = newCheckedList;
      } else {
        this.checkedList = this.checkedList.concat(actionIDs);
      }

      // 选中父级菜单
      const parentIds = findParentMenu(currentMenu, this.listRes, []);
      // 查看当前还有没有同级的选项
      const brotherIds = findBrotherMenu(currentMenu, this.listRes, []);
      let hasBrother = false;

      brotherIds.every(id => {
        if (this.checkedList.includes(`${id}`)) {
          hasBrother = true;
          return false;
        }
        return true;
      });

      if (hasBrother) {
        this.checkedList = this.checkedList.concat(parentIds || []);
      } else {
        const checkedListStr = this.checkedList.join(',');
        parentIds.forEach(id => {
          // 查找该菜单下是否有子菜单被选中
          const currentChidrenMenu = this.listAll
            .filter(
              item => item.parentId === Number(id) && this.checkedList.includes(String(item.id))
            )
            .map(item => item.id);

          // 查询当前父级ID下是否有子集选中
          if (!new RegExp(`${id}-`, 'gi').test(checkedListStr) && currentChidrenMenu.length === 0) {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
          }
        });
      }

      // 去重
      this.checkedList = Array.from(new Set(this.checkedList));
    },
  },
};
</script>
<style lang="less" scoped>
.form {
  padding-bottom: 20px;
}

.item-list {
  ul {
    li {
      border-bottom: #eee solid 1px;
      padding: 5px 0 20px 0;
      &.children {
        ul {
          padding-top: 20px;
        }
      }
    }
  }
}
</style>
